<script setup lang="ts">
import { BaseCard } from '@/components/Cards'
import { DialogActions, DialogHeader } from '@/components/Modals/Dialog'
import { computed, getCurrentInstance } from 'vue'
type Props = {
    title?: string
    open: boolean
    closeLabel?: string
    confirmLabel?: string
    noFooter?: boolean
    disabled?: boolean
    loading?: boolean
}
defineProps<Props>()
type Emits = {
    (e: 'close', event?: MouseEvent): void
    (e: 'confirm'): void
    (e: 'backdropClick'): void
}
defineEmits<Emits>()

const hasCancelDefined = computed(() => !!getCurrentInstance()?.vnode.props?.onBackdropClick)
</script>

<template>
    <b-modal
        :modelValue="open"
        has-modal-card
        trap-focus
        :destroy-on-hide="false"
        @close="hasCancelDefined ? $emit('backdropClick') : $emit('close', $event)"
        aria-role="dialog"
        :aria-label="title"
        aria-modal
        class="modal-dialog"
        v-bind="$attrs">
        <BaseCard class="modal-card">
            <template #title v-if="title">
                <DialogHeader :title="title" @close="$emit('close', $event)" />
            </template>
            <template #content><slot name="content" /></template>
            <template #footer v-if="!noFooter">
                <DialogActions
                    :confirmLabel="confirmLabel"
                    :closeLabel="closeLabel"
                    :disabled="disabled"
                    :loading="loading"
                    @close="$emit('close')"
                    @confirm="$emit('confirm')">
                    <slot name="actions" />
                </DialogActions>
            </template>
        </BaseCard>
    </b-modal>
</template>
